import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { getChannelLabel } from 'data/channels/helpers'
import { providesNoteMutations } from 'components/Notes/dataSync/note'

import IncentiveBox from 'components/Utils/IncentiveBox'
import { selectors as OrganizationsSelectors } from 'data/organizations'
import { selectors as ChannelsSelectors } from 'data/channels'
import { selectors as UsersSelectors } from 'data/users'
import { setActiveModal } from 'data/ui/actions'
import Radio from 'components/Utils/Form/Radio'
import { AddUserIcon } from 'components/Utils/Icons'
import LinkCopiable from './LinkCopiable'
import {
  INVITE_OAUTH_MEMBERS,
  CHANNEL_SETTINGS,
} from 'components/Utils/Modal/constants'
import ChannelIcon from 'components/Utils/ChannelIcon'
import SelectLinkSharingOption from 'components/Utils/SelectLinkSharingOption'
import {
  publicSharingOptionsMap,
  publicSharingOptions,
} from 'remote/share/sharingOptions'
import ShareTo from './ShareTo'
import EmailForm from './EmailForm'

class PopoverContent extends React.Component {
  state = {
    displayEmailForm: false,
  }

  onRadioChange = event => {
    const { note, publiclyShareNote, publiclyUnshareNote } = this.props
    const { id } = note
    const isPubliclyShared = !!note.publiclySharedAt
    if (isPubliclyShared) {
      publiclyUnshareNote({ id })
    } else {
      publiclyShareNote({ id })
    }
  }
  onSelectPublicSharingOption(publicSharingOptionSelected) {
    const {
      note,
      makePublicNoteEditable,
      makePublicNoteNonEditable,
    } = this.props
    const { id } = note
    const isMadePubliclyEditable = !!note.madePubliclyEditableAt
    if (isMadePubliclyEditable && publicSharingOptionSelected === 'read') {
      makePublicNoteNonEditable({ id })
    } else if (
      !isMadePubliclyEditable &&
      publicSharingOptionSelected === 'edit'
    ) {
      makePublicNoteEditable({ id })
    }
  }

  onAddPeopleClick = () => {
    const { closePopover, setActiveModal } = this.props
    closePopover()
    setActiveModal({
      id: INVITE_OAUTH_MEMBERS,
      analytics: {
        type: 'INVITE_FROM_SHARE',
      },
    })
  }

  render() {
    const {
      note,
      closePopover,
      eventBusStore,
      channel,
      setActiveModal,
      canInvite,
      canSharePublicly,
      canShareToInTegrations,
    } = this.props
    const isPubliclyShared = Boolean(note.publiclySharedAt)
    const isMadePubliclyEditable = Boolean(note.madePubliclyEditableAt)
    const currentPublicSharingOption = isMadePubliclyEditable
      ? publicSharingOptions.EDIT
      : publicSharingOptions.READ
    const channelIsPubliclyShared = channel && channel.publiclySharedAt
    const shareableOrIsShared = canSharePublicly || isPubliclyShared

    const containerClasses =
      'radius-normal background-shade-100 border-none shadow-hovering margin-top-large'

    if (this.state.displayEmailForm) {
      return (
        <div className={containerClasses} style={{ width: 430 }}>
          <EmailForm
            note={note}
            toggleOffEmailForm={() =>
              this.setState({ displayEmailForm: false })
            }
            closePopover={closePopover}
          />
        </div>
      )
    }

    return (
      <div style={{ width: 430 }} className={containerClasses}>
        <React.Fragment>
          <div className="padding-top-medium flexbox flexbox-column padding-bottom-small padding-horizontal-medium">
            {shareableOrIsShared && (
              <Radio onChange={this.onRadioChange} checked={isPubliclyShared}>
                <div className="shade-05">
                  <div className="bold margin-bottom-smaller">Public link</div>
                  <div className="flexbox">
                    Anyone on the web with this link can{' '}
                    {canSharePublicly ? (
                      <SelectLinkSharingOption
                        currentPublicSharingOption={currentPublicSharingOption}
                        publicSharingOptions={publicSharingOptionsMap}
                        onSelectPublicSharingOption={publicSharingOptionSelected =>
                          this.onSelectPublicSharingOption(
                            publicSharingOptionSelected
                          )
                        }
                      />
                    ) : (
                      <span>
                        {
                          publicSharingOptionsMap[currentPublicSharingOption]
                            .inlineText
                        }
                      </span>
                    )}
                  </div>
                </div>
              </Radio>
            )}
            {(canSharePublicly || !isPubliclyShared) && (
              <Radio onChange={this.onRadioChange} checked={!isPubliclyShared}>
                <div className="shade-05">
                  <div className="bold margin-bottom-smaller">Private link</div>
                  <div className="flexbox flexbox-align-center flexbox-wrap">
                    <div>Only members in </div>
                    <div
                      className=" padding-horizontal-smaller radius-normal background-shade-50 margin-horizontal-smaller"
                      style={{ verticalAlign: 'middle' }}
                    >
                      <ChannelIcon
                        channel={channel}
                        size={12}
                        className="margin-right-smaller"
                      />
                      {getChannelLabel(channel)}
                    </div>
                    <div> can read this doc.</div>
                  </div>
                  {channelIsPubliclyShared && (
                    <div className="shade-10 flexbox flexbox-wrap flexbox-align-center">
                      Users with the channel
                      <div
                        className="underline margin-horizontal-smaller"
                        onClick={() =>
                          setActiveModal({
                            id: CHANNEL_SETTINGS,
                            meta: {
                              channelId: channel.id,
                              defaultTabId: 'sharing',
                            },
                          })
                        }
                      >
                        {' '}
                        sharing link
                      </div>
                      can still read this doc
                    </div>
                  )}
                </div>
              </Radio>
            )}
          </div>
          {this.props.isFree && (
            <IncentiveBox
              incentiveId="ManagePublicNotes"
              className="margin-horizontal-medium margin-bottom-normal"
            />
          )}
          <div className="flexbox flexbox-align-center background-shade-50 flexbox-space-between slite-design-system">
            {canInvite ? (
              <div
                onClick={this.onAddPeopleClick}
                className="flexbox flexbox-align-center shade-20 shade-10-on-hover pointer margin-left-larger"
              >
                <AddUserIcon size={16} className="margin-right-small" />
                <span className="bold">Add people to Slite</span>
              </div>
            ) : (
              // this is for spacing purpose
              <div />
            )}
            <LinkCopiable link={note.shareLink}>
              <span className="padding-horizontal-large padding-vertical-normal line-height-normal">
                Copy link
              </span>
            </LinkCopiable>
          </div>
          {canShareToInTegrations && (
            <ShareTo
              note={note}
              closePopover={closePopover}
              eventBusStore={eventBusStore}
              toggleOnEmailForm={() =>
                this.setState({ displayEmailForm: true })
              }
            />
          )}
        </React.Fragment>
      </div>
    )
  }
}

export default compose(
  providesNoteMutations,
  connect(
    (state, { note }) => {
      const channel = ChannelsSelectors.getChannel(state, note.channelId)
      return {
        channel,
        canSharePublicly: channel && channel.permissions.get('sharePublicly'),
        canShareToInTegrations:
          channel && channel.permissions.get('shareToIntegrations'),
        isFree: OrganizationsSelectors.isFree(state),
        canInvite: UsersSelectors.canCurrentUserInviteMembers(state),
      }
    },
    { setActiveModal }
  )
)(PopoverContent)
